import MainPage from "../components/pages/main-page/MainPage";
import EmbedPage from "../components/pages/embed-page/EmbedPage";
import {Navigate, Route, Routes} from "react-router-dom";


function AppRoutes() {
    return (
        <Routes>
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/" element={<MainPage />} />
            <Route path="embed" element={ <EmbedPage /> }/>
        </Routes>
    )
}

export default AppRoutes;